import {
    Chart as ChartJS,
    LineElement,
    PointElement,
    LinearScale,
    CategoryScale,
    Tooltip,
    Title,
    Filler,
} from 'chart.js';
import { Line } from 'react-chartjs-2';

ChartJS.register(
    LineElement,
    PointElement,
    LinearScale,
    CategoryScale,
    Tooltip,
    Title,
    Filler
);

const AreaChart = ({ data, title }) => {

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            title: {
                display: true,
                text: title,
                font: {
                    size: 24,
                },
                color: '#fff'
            },
            legend: {
                display: false
            }
        },
        scales: {
            y: {
                beginAtZero: true,
                ticks: {
                    font: {
                        size: 18,
                    },
                    color: '#fff'
                },
            },
            x: {
                ticks: {
                    font: {
                        size: 18,
                    },
                    color: '#fff'
                },
            },
        },
    };

    return (
        <div className='graph'>
            <Line data={data} options={options} />
        </div >
    );
};

export default AreaChart;
